class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    document.addEventListener('keyup', this.onKeyUp.bind(this));
    document.addEventListener('click', this.onFocusOut.bind(this));
  }

  onKeyUp(event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }

  onFocusOut(e) {
    if (!this.mainDetailsToggle) return;

    const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

    if (!withBoundaries) {
      this.mainDetailsToggle.removeAttribute('open');
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
